import { sdk } from 'sdk';
import { Cart } from 'shared/types/cart';

const useSubscription = () => {
  const getAllSubscriptions = async (): Promise<Cart[]> => {
    const res = await sdk.callAction<Cart[]>({ actionName: 'subscription/getAllSubscriptions' });

    if (res.isError) return [];

    return res.data || [];
  };
  return {
    getAllSubscriptions,
  };
};

export default useSubscription;
